import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/pay.png';
import _imports_1 from '@/assets/imgs/top.png';
import _imports_2 from '@/assets/imgs/swap/$-left.png';
import _imports_3 from '@/assets/imgs/swap/swap.png';
import _imports_4 from '@/assets/imgs/swap/btc.png';
import _imports_5 from '@/assets/imgs/swap/eth.png';
import _imports_6 from '@/assets/imgs/swap/$-right.png';
import _imports_7 from '@/assets/imgs/“.svg';
import _imports_8 from '@/assets/imgs/about.webp';
import _imports_9 from '@/assets/imgs/phone.webp';
const _withScopeId = n => (_pushScopeId("data-v-3137f1ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "children:container children:mx-a children:px-5 space-y-15 md:space-y-30"
};
const _hoisted_2 = {
  class: "flex items-center flex-col lg:flex-row gap-5"
};
const _hoisted_3 = {
  class: "flex-1 flex gap-2 flex-col items-center lg:items-start"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "flex items-center mt-[76px] mb-[56px]"
};
const _hoisted_6 = {
  class: "mr-[37px]"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "text-[32px] font-medium"
}, "150+", -1));
const _hoisted_8 = {
  class: "text-sm text-[#838489]"
};
const _hoisted_9 = {
  class: "mr-[60px]"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "text-[32px] font-medium"
}, "75+", -1));
const _hoisted_11 = {
  class: "text-sm text-[#838489]"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: ""
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "w-[154px]",
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_13 = {
  href: "/contact",
  class: "py-4 px-8 bg-[#4B7CDD] font-medium text-white rounded-md"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-main w-[636px]",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_15 = {
  class: "flex gap-7 flex-col md:flex-row"
};
const _hoisted_16 = {
  class: "green aspect-1170/760 flex flex-col items-center justify-center flex-1"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex items-center justify-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "w-[104px] lg:w-150px xl:w-208px",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "w-[39px] lg:w-50px xl:w-78px",
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "w-[104px] lg:w-150px xl:w-208px",
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_18 = {
  class: "text-center"
};
const _hoisted_19 = {
  class: "text-white lg:text-2xl font-medium text-xl"
};
const _hoisted_20 = {
  class: "mt-3 text-white8 px-5 text-sm md:text-base"
};
const _hoisted_21 = {
  class: "blue aspect-1170/760 flex flex-col items-center justify-center flex-1"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex items-center justify-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "w-[104px] lg:w-150px xl:w-208px",
  src: _imports_5,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "w-[39px] lg:w-50px xl:w-78px",
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "w-[104px] lg:w-150px xl:w-208px",
  src: _imports_6,
  alt: ""
})], -1));
const _hoisted_23 = {
  class: "text-center"
};
const _hoisted_24 = {
  class: "text-white lg:text-2xl font-medium text-xl"
};
const _hoisted_25 = {
  class: "mt-3 text-white8 px-5 text-sm md:text-base"
};
const _hoisted_26 = {
  class: ""
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "text-center text-5xl font-medium mb-20"
}, "Why Mixin Route", -1));
const _hoisted_28 = {
  class: "text-left grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-[180px]"
};
const _hoisted_29 = {
  class: "bg-[#F0F5F8] pt-7 pb-8 px-8"
};
const _hoisted_30 = {
  class: "icon w-[68px] h-[68px] flex justify-center items-center rounded-lg bg-white"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  class: "mt-6 mb-3 text-[20px] font-medium"
};
const _hoisted_33 = {
  class: "text-gray8 leading-[26px]"
};
const _hoisted_34 = {
  class: ""
};
const _hoisted_35 = {
  class: "text-5xl text-center font-medium"
};
const _hoisted_36 = {
  class: "mt-5 mb-[60px] text-gray8 text-center mx-auto"
};
const _hoisted_37 = {
  class: "flex gap-5 flex-col xl:flex-row"
};
const _hoisted_38 = {
  class: "grid grid-cols-2 md:grid-cols-3 bg-white p-4 md:p-8 gap-x-[27px] gap-y-[24px] rounded-md shadow1"
};
const _hoisted_39 = {
  class: "w-[142px] mx-a h-[112px] flex flex-col items-center justify-center border border-solid border-[#D4DAE5] rounded-md"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = {
  class: "text-sm text-safeBlack mt-2"
};
const _hoisted_42 = {
  class: "flex-1 grid items-center justify-center md:grid-cols-2 gap-5"
};
const _hoisted_43 = {
  class: "w-full h-[214px] bg-white rounded-md px-8 pt-9 shadow1"
};
const _hoisted_44 = {
  class: "text-xl font-medium text-safeBlack mb-4"
};
const _hoisted_45 = {
  class: "text-sm text-gray8"
};
const _hoisted_46 = {
  class: "code hidden! flex wrap h-[509px] p-[42px] pl-[120px] text-white gap-[100px] mb-[160px]"
};
const _hoisted_47 = {
  class: "flex-1 mt-8"
};
const _hoisted_48 = ["innerHTML"];
const _hoisted_49 = {
  class: "mt-5 mb-[68px] w-[456px] leading-[32px]"
};
const _hoisted_50 = {
  class: "px-[42px] py-4 bg-[#4B7CDD] rounded-md"
};
const _hoisted_51 = {
  class: "flex-1 w-[484px] h-[425px] border border-solid border-[#5BBC7A] rounded-2xl bg-[#333a4a]"
};
const _hoisted_52 = {
  class: "relative text-center text-[#5BBC7A] leading-[46px]"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "left-5 top-4 absolute w-3.5 h-3.5 rounded-full border border-solid border-[#5BBC7A]"
}, null, -1));
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "left-[46px] top-4 absolute w-3.5 h-3.5 rounded-full border border-solid border-[#5BBC7A]"
}, null, -1));
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "left-[72px] top-4 absolute w-3.5 h-3.5 rounded-full border border-solid border-[#5BBC7A]"
}, null, -1));
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("pre", {
  class: "pl-[72px] pr-[52px] text-[15px] -mt-[28px] leading-[22px]"
}, [/*#__PURE__*/_createTextVNode("          "), /*#__PURE__*/_createElementVNode("code", {
  class: "break-all whitespace-pre-line"
}, "\n\nimport { MixinRouteSDK } from\n{'@'}mixin-route/mixin-route-sdk';\n\n/*\n  Quick Integration\n*/\nnew MixinRouteSDK({\nhostAppName{':'} Mixin Route Partner',\nhostLogoUrl:'https://images.mixin.one/UasWtBZO0TZyLTLCFQjvE_UYekjC7eHCuT_9_52ZpzmCC-X-NPioVegng7Hfx0XmIUavZgz5UL-HIgPCBECc-Ws=s128'，\nenabledFlows: ['ONRAMP', 'OFFRAMP'],\nhostApiKey:'--your-api-key--'\n}).show();\n          "), /*#__PURE__*/_createTextVNode("\n        ")], -1));
const _hoisted_57 = {
  class: "customer mx-0 bg-[#F4F8FF] w-full max-w-full px-0"
};
const _hoisted_58 = {
  class: "container mx-a px-5 pt-[100px] pb-25"
};
const _hoisted_59 = {
  class: "text-5xl mb-20 text-center"
};
const _hoisted_60 = {
  class: "flex rounded-2xl flex-col lg:flex-row overflow-hidden"
};
const _hoisted_61 = {
  class: "bg-[#333A4A]"
};
const _hoisted_62 = {
  class: "pt-[94px] pl-[90px] pb-10 pr-[64px] tracking-tight relative overflow-hidden"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "absolute top-[48px] left-[20px] scale-50"
}, null, -1));
const _hoisted_64 = {
  class: "text-lg leading-[36px] text-white"
};
const _hoisted_65 = {
  class: "text-white text-xl"
};
const _hoisted_66 = {
  class: "text-[#D7DDE1] mt-4"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "lg:w-[432px]",
  src: _imports_8,
  alt: "about"
}, null, -1));
const _hoisted_68 = {
  class: "started w-full max-w-full px-0"
};
const _hoisted_69 = {
  class: "flex flex-col lg:flex-row items-center justify-center lg:justify-around"
};
const _hoisted_70 = {
  class: "flex flex-col items-center justify-center pt-25 pb-10 lg:py-0 lg:items-start lg:w-fit"
};
const _hoisted_71 = ["innerHTML"];
const _hoisted_72 = {
  href: "/contact",
  class: "px-10 py-4 bg-white mt-12 rounded-md font-medium text-[#4B7CDD]"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  class: "w-[400px] h-[492px]",
  src: _imports_9,
  alt: ""
})], -1));
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {
    const {
      t
    } = useI18n();
    const supportList = ["Mixin Messenger", "MixPay", "B.Watch", "4swap", "Quill", "TIGA", "OptionDance", "BigONE", "Trident"];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h2", {
        class: "home-title text-safeBlack text-5xl lg:text-[60px] text-center lg:text-start leading-[78px] font-medium",
        innerHTML: _unref(t)(`home.top.title`)
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)(`home.top.countries`)), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)(`home.top.currencies`)), 1)]), _hoisted_12]), _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(t)(`home.top.contact`)), 1)]), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("h3", _hoisted_19, _toDisplayString(_unref(t)(`home.top.on`)), 1), _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)(`home.top.onDesc`)), 1)])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("h3", _hoisted_24, _toDisplayString(_unref(t)(`home.top.off`)), 1), _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)(`home.top.offDesc`)), 1)])])]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("ul", _hoisted_28, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, i => {
        return _createElementVNode("li", _hoisted_29, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_30, [_createElementVNode("img", {
          class: "w-12",
          src: require(`@/assets/imgs/why/${i}.png`),
          alt: ""
        }, null, 8, _hoisted_31)]), _createElementVNode("h3", _hoisted_32, _toDisplayString(_unref(t)(`home.why.${i - 1}.title`)), 1), _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(t)(`home.why.${i - 1}.content`)), 1)])]);
      }), 64))])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("h2", _hoisted_35, _toDisplayString(_unref(t)(`home.support.title`)), 1), _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(t)(`home.support.desc`)), 1), _createElementVNode("div", _hoisted_37, [_createElementVNode("ul", _hoisted_38, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(supportList, item => {
        return _createElementVNode("li", _hoisted_39, [_createElementVNode("img", {
          class: "w-[48px]",
          src: require(`@/assets/imgs/support/${item}.png`),
          alt: ""
        }, null, 8, _hoisted_40), _createElementVNode("p", _hoisted_41, _toDisplayString(item), 1)]);
      }), 64))]), _createElementVNode("ul", _hoisted_42, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, item => {
        return _createElementVNode("li", _hoisted_43, [_createElementVNode("h4", _hoisted_44, _toDisplayString(_unref(t)(`home.support.items.${item - 1}.title`)), 1), _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(t)(`home.support.items.${item - 1}.desc`)), 1)]);
      }), 64))])])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("h2", {
        class: "dec2 text-5xl font-medium",
        innerHTML: _unref(t)(`home.code.title`)
      }, null, 8, _hoisted_48), _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(t)(`home.code.desc`)), 1), _createElementVNode("button", _hoisted_50, _toDisplayString(_unref(t)(`home.code.soon`)), 1)]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createTextVNode(_toDisplayString(_unref(t)(`home.code.file`)) + " ", 1), _hoisted_53, _hoisted_54, _hoisted_55]), _hoisted_56])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("h2", _hoisted_59, _toDisplayString(_unref(t)(`home.customer.title`)), 1), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_hoisted_63, _createElementVNode("p", _hoisted_64, _toDisplayString(_unref(t)(`home.customer.list[0].content`)), 1), _createElementVNode("p", _hoisted_65, _toDisplayString(_unref(t)(`home.customer.list[0].name`)), 1), _createElementVNode("p", _hoisted_66, _toDisplayString(_unref(t)(`home.customer.list[0].position`)), 1)])]), _hoisted_67])])]), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createElementVNode("h2", {
        class: "dec2 text-5xl text-center lg:text-start text-white",
        innerHTML: _unref(t)(`home.started.content`)
      }, null, 8, _hoisted_71), _createElementVNode("a", _hoisted_72, _toDisplayString(_unref(t)(`home.started.contact`)), 1)]), _hoisted_73])])]);
    };
  }
});